// extracted by mini-css-extract-plugin
module.exports = {"root":"Search_root__1YnoQ","btn":"Search_btn__3s8AS"};